module.exports = __webpack_public_path__ + "static/media/hala-icon.14de68f6.png";